import baseConfig from '@config/base.config';
import deviceInfo from '@utils/device.utils';
import cookieUtils from '@utils/cookie.utils';
import accountApis from '@/apis/config/graphql/account';

function isPromise(ret) {
    return ret && typeof ret.then === 'function' && typeof ret.catch === 'function';
}

const errorHandler = (error, vm, info) => {
    const { ACCOUNT_ID, LAST_PROFILE_ID } = baseConfig;
    const { href } = window.location;
    const uid = localStorage.getItem(ACCOUNT_ID) || cookieUtils.getItem(ACCOUNT_ID);
    const sid = cookieUtils.getItem(LAST_PROFILE_ID);
    accountApis.errorLog({
        data: {
            sid,
            uid,
            href,
            info: info + '',
            deviceInfo: JSON.stringify(deviceInfo),
            error: error.toString()
        }
    });
    return Promise.reject(error);
};

function registerActionHandle(actions) {
    Object.keys(actions).forEach(key => {
        let fn = actions[key];
        actions[key] = function (...args) {
            let ret = fn.apply(this, args);
            if (isPromise(ret)) {
                return ret.catch(errorHandler);
            } else {
                // 默认错误处理
                return ret;
            }
        };
    });
}
const registerVuex = instance => {
    if (instance.$options['store']) {
        let actions = instance.$options['store']['_actions'] || {};
        if (actions) {
            let tempActions = {};
            Object.keys(actions).forEach(key => {
                tempActions[key] = actions[key][0];
            });
            registerActionHandle(tempActions);
        }
    }
};
const registerVue = instance => {
    if (instance.$options.methods) {
        let actions = instance.$options.methods || {};
        if (actions) {
            registerActionHandle(actions);
        }
    }
};

let VueError = {
    install: (Vue, options) => {
        /**
         * 全局异常处理
         * @param {*} error
         * @param {*} vm
         */
        Vue.config.errorHandler = errorHandler;
        Vue.mixin({
            beforeCreate() {
                registerVue(this);
                registerVuex(this);
            }
        });
        Vue.config.globalProperties.$throw = errorHandler;
    }
};

export default VueError;
